
import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from 'react-router-dom'
import Loader from "./components/common/Loader";
import { useAuthStore } from "@/stores/authStore";
import LandingPage from "./pages/landingPage";
import PortalLayout from "@/components/layout/PortalLayout";

// * Lazy load pages to improve initial load performance.
const LoginPage = lazy(() => import('@/pages/login'))
const HomePage = lazy(() => import('@/pages/portal/home'))
const ProfilePage = lazy(() => import('@/pages/portal/profile'))
const RewardsPage = lazy(() => import('@/pages/portal/rewards'))
const TransactionsPage = lazy(() => import('@/pages/portal/transactions'))
const AboutPage = lazy(() => import('@/pages/portal/about'))
const SignupPage = lazy(() => import('@/pages/signup'))
const VerifyPage = lazy(() => import('@/pages/signup/verify'))
const TermsPage = lazy(() => import('@/pages/terms'))
const PolicyPage = lazy(() => import('@/pages/policy'))

export default function RoutesComponent() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={isAuthenticated ? <Navigate to="/portal/home" /> : <LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy-policy" element={<PolicyPage />} />

        {/* Protected Routes */}
        <Route path="portal" element={<PortalLayout />}>
          <Route index path="home" element={<HomePage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="rewards" element={<RewardsPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="about" element={<AboutPage />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<div>404 Page Not Found</div>} />
      </Routes>
    </Suspense>
  )
}